import { FC } from 'react';
import { TypeHomepageHeroFields, TypeImage } from '@/core/generated-types';
import { BackgroundColorWrapper } from '@/components/common/BackgroundColorWrapper';
import { isVideo, isMuxVideo } from '@/components/common/LandingPageHero/utils';
import { CONTENT_TYPE_HOMEPAGE_HERO } from '@/core/constants';
import {
  FullImage,
  SideBySide,
  Offset,
  Parallax,
} from '@/components/common/HomepageHero/versions';
import { PromoRichText } from './versions/PromoRichText';

export const HomepageHero: FC<TypeHomepageHeroFields> = (props) => {
  let altText = '';
  let typeImage: TypeImage | undefined;

  const mobileMediaIsVideo =
    isVideo(props.mobileMedia) || isMuxVideo(props.mobileMedia);
  if (!mobileMediaIsVideo) {
    typeImage = props.mobileMedia as TypeImage;
    altText = typeImage?.fields.altText ?? '';
  }

  const mergedProps = { ...props, mobileMediaIsVideo, altText, typeImage };
  const versionMap = {
    [CONTENT_TYPE_HOMEPAGE_HERO.FULL_IMAGE]: <FullImage {...mergedProps} />,
    [CONTENT_TYPE_HOMEPAGE_HERO.PARALLAX]: <Parallax {...mergedProps} />,
    [CONTENT_TYPE_HOMEPAGE_HERO.SIDE_BY_SIDE]: <SideBySide {...mergedProps} />,
    [CONTENT_TYPE_HOMEPAGE_HERO.OFFSET]: <Offset {...mergedProps} />,
    [CONTENT_TYPE_HOMEPAGE_HERO.PROMO_RICH_TEXT]: (
      <PromoRichText {...mergedProps} />
    ),
  };

  return (
    <BackgroundColorWrapper
      color={props.backgroundColor?.fields?.color}
      classes="display-unset"
    >
      {versionMap[props.version]}
    </BackgroundColorWrapper>
  );
};

export interface ExtendedTypeHomepageHeroFields extends TypeHomepageHeroFields {
  mobileMediaIsVideo: boolean;
  altText: string;
  typeImage: TypeImage | undefined;
}
